import type { TinaMarkdownContent } from 'tinacms/dist/rich-text';


export const filterTinaMarkdownContentParagraphs = (value: TinaMarkdownContent, replacement: string | null = 'break'): TinaMarkdownContent => {
    const root = value?.children;

    const filtred = root?.flatMap((child, index) => {
        return child.type === 'p' ? (replacement && index < root.length - 1 ? [...child.children, { type: replacement, children: [] }] : child.children) : child;
    });    
    
    return {
        children: filtred || [],
        type: 'root'
    }
};